import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Box, Button } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { qrDialogPaperSx, QrModalHeader, QR } from "../qrCode/components/qrUi";
import Slide from "@mui/material/Slide";

// TAB WISE DISPLAYING FILES IMPORTS
import ContactEdit from "./contactEdit";
import ViewUserMediaFileDetails from "./viewUserMediaFileDetails";
import UserForms1 from "./userForms1";
import TaskUpdation from "../leadMangement/components/myTask/taskUpdation";
import BranchDeptOrganizations from "./branchDeptOrganizations";
import { getLeadStatusTypesThunk, getCallStatusTypesThunk } from "../leadMangement/leadMangementThunk";
import { useDispatch } from "react-redux";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ContactProfileTabModal({ show, handleClose, rowData, type }) {
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        if (show) {
            setTabValue(0);
            dispatch(getLeadStatusTypesThunk());
            dispatch(getCallStatusTypesThunk());
        }
    }, [show, dispatch])

    const renderContent = () => {
        switch (tabValue) {
            case 0:
                return
            case 1:
                return
            case 2:
                return
            case 3:
                return
            case 4:
                return
            default:
                return null;
        }
    };

    return (
        <>
            <Dialog
                open={show}
                onClose={handleClose}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="md"
                keepMounted
                PaperProps={{ sx: qrDialogPaperSx }}
            >
                {/* Header */}
                <QrModalHeader
                    icon={<PersonIcon />}
                    title="Profile"
                    subtitle={rowData?.name || rowData?.contact_name || undefined}
                    onClose={handleClose}
                />

                {/* Content */}
                <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', height: tabValue === 0 ? '350px' : tabValue === 3 ? '400px' : '500px', minHeight: 0, maxHeight: { xs: 'calc(100dvh - 100px)', sm: 'calc(100vh - 160px)' } }}>
                    <Box sx={{ width: "100%" }}>
                        {/* Tabs (underline) */}
                        <Box
                            sx={{
                                display: "flex",
                                gap: 0.5,
                                px: { xs: 1, sm: 2 },
                                overflowX: "auto",
                                bgcolor: "#f8fafc",
                                borderBottom: `1px solid ${QR.border}`,
                                "&::-webkit-scrollbar": { display: "none" },
                            }}
                        >
                            {[
                                { label: "Edit Profile", value: 0, icon: <ManageAccountsOutlinedIcon /> },
                                { label: "Media", value: 1, icon: <PermMediaOutlinedIcon /> },
                                { label: "Forms", value: 2, icon: <DescriptionOutlinedIcon /> },
                                { label: "Tags", value: 3, icon: <LocalOfferOutlinedIcon /> },
                                { label: "Lead Updation", value: 4, icon: <TrendingUpIcon /> },
                            ].map((tab) => {
                                const active = tabValue === tab.value;
                                return (
                                    <Button
                                        key={tab.value}
                                        onClick={() => setTabValue(tab.value)}
                                        startIcon={tab.icon}
                                        sx={{
                                            position: "relative",
                                            flexShrink: 0,
                                            height: 46,
                                            px: { xs: 1.25, sm: 1.75 },
                                            borderRadius: 0,
                                            textTransform: "none",
                                            fontSize: 13.5,
                                            fontWeight: active ? 800 : 600,
                                            whiteSpace: "nowrap",
                                            color: active ? QR.main : "#64748b",
                                            "& .MuiButton-startIcon svg": { fontSize: 18 },
                                            "&::after": {
                                                content: '""',
                                                position: "absolute",
                                                left: 10,
                                                right: 10,
                                                bottom: -1,
                                                height: 3,
                                                borderRadius: "3px 3px 0 0",
                                                background: active ? `linear-gradient(90deg, ${QR.main}, ${QR.light})` : "transparent",
                                            },
                                            "&:hover": { bgcolor: active ? "transparent" : "#eef2f6", color: active ? QR.main : "#0f172a" },
                                        }}
                                    >
                                        {tab.label}
                                    </Button>
                                );
                            })}
                        </Box>

                        {/* Tab Content */}
                        {renderContent()}
                    </Box>

                    {/* Tab Content - Scrollable */}
                    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', p: { xs: 1.5, sm: 2 } }}>
                        {tabValue === 0 && <ContactEdit handleClose={handleClose} show={show} contact_id={rowData?.wa_contact_id} updationType={type} />}
                        {tabValue === 1 && <ViewUserMediaFileDetails show={show} handleClose={handleClose} updationType={type} />}
                        {tabValue === 2 && <UserForms1 show={show} handleClose={handleClose} updationType={type} contact_id={rowData?.wa_contact_id} />}
                        {tabValue === 3 && <BranchDeptOrganizations show={show} handleClose={handleClose} updationType={type} />}
                        {tabValue === 4 && <TaskUpdation rowData={rowData} show={show} handleClose={handleClose} updationType={type} />}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}